import { useEffect, useState, type ReactNode } from "react";
import {
  Activity,
  BadgePlus,
  BookOpenText,
  ChevronRight,
  CircleGauge,
  KeyRound,
  ListVideo,
  LogOut,
  Menu,
  ServerCog,
  Settings,
  Users,
  X,
} from "lucide-react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { api } from "../lib/api";

const navigation = [
  { to: "/", label: "概览", icon: CircleGauge, end: true },
  { to: "/accounts", label: "账号", icon: Users },
  { to: "/google-max", label: "Max 初始化", icon: BadgePlus },
  { to: "/tasks", label: "任务", icon: ListVideo },
  { to: "/api-keys", label: "API Keys", icon: KeyRound },
  { to: "/logs", label: "日志", icon: BookOpenText },
  { to: "/workers", label: "Workers", icon: ServerCog },
  { to: "/metrics", label: "指标", icon: Activity },
  { to: "/settings", label: "设置", icon: Settings },
] as const;

export default function AppShell({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const current = navigation.find((item) => item.to === location.pathname)?.label || "控制台";

  useEffect(() => setOpen(false), [location.pathname]);

  async function logout() {
    await api.logout();
    navigate("/login", { replace: true });
  }

  return (
    <div className="app-shell">
      <aside className={`sidebar ${open ? "sidebar-open" : ""}`} aria-label="主导航">
        <div className="brand">
          <span className="brand-mark">HF</span>
          <span>
            <strong>Higgsfield2API</strong>
            <small>Operations Console</small>
          </span>
          <button className="icon-button sidebar-close" type="button" onClick={() => setOpen(false)} aria-label="关闭导航">
            <X size={18} />
          </button>
        </div>
        <nav className="sidebar-nav">
          {navigation.map(({ to, label, icon: Icon, ...item }) => (
            <NavLink key={to} to={to} end={"end" in item ? item.end : false}>
              <Icon size={17} />
              <span>{label}</span>
              <ChevronRight className="nav-chevron" size={14} />
            </NavLink>
          ))}
        </nav>
        <div className="sidebar-footer">
          <span className="environment-dot" />
          <span>Production</span>
          <button type="button" className="icon-button" onClick={() => void logout()} title="退出登录" aria-label="退出登录">
            <LogOut size={17} />
          </button>
        </div>
      </aside>
      {open && <button className="sidebar-scrim" onClick={() => setOpen(false)} aria-label="关闭导航" />}
      <div className="app-main">
        <header className="topbar">
          <button className="icon-button mobile-menu" type="button" onClick={() => setOpen(true)} aria-label="打开导航">
            <Menu size={19} />
          </button>
          <div>
            <span className="topbar-context">Higgsfield2API</span>
            <h1>{current}</h1>
          </div>
          <div className="topbar-state"><span className="environment-dot" /> 服务已连接</div>
        </header>
        <main className="content">{children}</main>
      </div>
    </div>
  );
}
